import image from '../../assets/img/author_verified.svg';

interface VerifiedIconProps {
    alt?: string;
    className?: string | null;
}

function VerifiedIcon({ alt, className }: VerifiedIconProps) {
    return <img src={image} className={className} alt={alt} />;
}

export default VerifiedIcon;
